/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 29/09/2020  
 */
const loginResponse = () => {
    return {
        access_token:null,
        expires_in: null,
        id_token: null,
        not_before_policy: null,
        refresh_expires_in: null,
        refresh_token: null,
        scope: null,
        session_state: null,
        token_type: null,
    }

}

export default loginResponse;